import { useState, useEffect } from 'react';
import BuildWell from './pages/BuildWell';
import ClientPortal from './pages/ClientPortal';
import FAQPage from './pages/FAQPage';

export default function App() {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  const lower = path.toLowerCase();
  if (lower.startsWith('/clientportal')) return <ClientPortal />;
  if (lower.startsWith('/faq')) return <FAQPage />;
  return <BuildWell />;
}
